// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../../../../Users/qiancheng/Documents/Workspace/cargoware/cargoware-h5-haichuang/node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#app .main-content[data-v-6abda205]  .el-loading-mask {\n  z-index: 999999;\n}\n.responsibility-dialog[data-v-6abda205]  .el-dialog__body {\n  padding: 0;\n}\n.step[data-v-6abda205] {\n  height: 300px;\n}\n.step-title[data-v-6abda205] {\n  height: 60px;\n  line-height: 60px;\n  padding-left: 20px;\n  background: #c0c0c0;\n  font-size: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
